// extracted by mini-css-extract-plugin
export default {"block":"Filter_block__MT+Zz","blockSelected":"Filter_blockSelected__0+OuN","title":"Filter_title__vIkef","content":"Filter_content__mWdtW"};